/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dashboard-panel-component.ts
 *
 * Created by randysorensen on 2019-02-19.
 */

function DashboardPanelController (
    this: JS5Object,
    _: JS5Object,
    MetricsDashboardService: JS5Object
) {

    const onMetricsDataUpdated = (newMetricsData: JS5Object) => {
        this.metricsData = _.cloneDeep(newMetricsData);
    };

    this.getPanelData = () => {
        return _.get(this, 'panelData') || _.get(this, `metricsData[${this.panelDataProperty}]`);
    };

    this.$onInit = () => {
        this.metricsData = {};

        MetricsDashboardService.registerDataUpdateCallback(onMetricsDataUpdated);
    };

}

angular.module('prism-ui.metricsDashboard').component('dashboardPanel', {
    controller: DashboardPanelController,
    templateUrl: 'dashboard/metrics/dashboard-panels/dashboard-panel-template.html',
    bindings: {
        headerBGColor: '<',
        headerTextSize: '<',
        headerLabel: '<',
        panelData: '<',
        panelDataProperty: '<',
        panelTemplateUrl: '<',
        panelTextSize: '<'
    }
});
